import { useContext } from 'react';
import { ThemeContext } from 'styled-components';

const useColor = color => {
  const theme = useContext(ThemeContext);
  const colors = {
    white: theme.base.white,
    black: theme.secondary.dark
  };
  return colors[color];
};

export default useColor;